import { render } from "./LanguageIconSelector.vue?vue&type=template&id=2f2c6451"
import script from "./LanguageIconSelector.vue?vue&type=script&lang=js"
export * from "./LanguageIconSelector.vue?vue&type=script&lang=js"
script.render = render

export default script